import React, { useId } from 'react';

interface BrandIconProps {
  className?: string;
  height?: number;
}

/**
 * Direction B brand mark — icon-only extract from intrnauts-ai-logo.svg.
 * Per RESEARCH.md Pitfall 4, the linearGradient id is uniquified via
 * useId() so multiple instances on one page (topbar + footer) do NOT
 * collide. Rendered with aria-hidden because the wordmark sits next
 * to it in the DOM for assistive tech.
 */
export const BrandIcon: React.FC<BrandIconProps> = ({ className, height = 30 }) => {
  const reactId = useId();
  // useId returns ":r0:" style values which are not valid in SVG id refs
  // pre-React-18.3 in some Safari versions; sanitize the colons.
  const gradId = `ai-cloud-grad-${reactId.replace(/:/g, '')}`;
  return (
    <svg
      className={className}
      viewBox="0 0 250 190"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      style={{ height, width: 'auto', display: 'block' }}
    >
      <defs>
        <linearGradient id={gradId} x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0" stopColor="#1e3f66" />
          <stop offset="1" stopColor="#3a6da3" />
        </linearGradient>
      </defs>
      <path
        d="M40,75C15,80,0,105,0,130c0,35,25,60,60,60h130c30,0,55-25,55-55s-25-55-55-55c-10-35-40-65-80-65-35,0-65,25-70,60"
        fill={`url(#${gradId})`}
      />
      <rect x="150" y="0" width="20" height="20" fill="#0a2342" />
      <g stroke="#fff" strokeWidth="2" opacity="0.7" fill="none">
        <line x1="150" y1="50" x2="120" y2="90" />
        <line x1="150" y1="50" x2="180" y2="90" />
        <line x1="120" y1="90" x2="90" y2="130" />
        <line x1="120" y1="90" x2="150" y2="130" />
        <line x1="180" y1="90" x2="150" y2="130" />
        <line x1="180" y1="90" x2="210" y2="130" />
      </g>
      <g fill="#fff">
        <circle cx="150" cy="50" r="8" />
        <circle cx="120" cy="90" r="8" />
        <circle cx="180" cy="90" r="8" />
        <circle cx="90" cy="130" r="8" />
        <circle cx="150" cy="130" r="8" />
        <circle cx="210" cy="130" r="8" />
      </g>
    </svg>
  );
};

export default BrandIcon;
